//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import template from 'app/bulk-actions/bulk-actions-confirmation-modal/bulk-actions-confirmation-modal.html';

angular.module('curalate').component('bulkActionsConfirmationModal', {
  bindings: {
    confirmationCta: '@',
    confirmationMessage: '@',
    onCancel: '&',
    onComplete: '&',
    requiredPermission: '@',
  },
  template,
});
